<template>
  <div class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title title="代理方" />
      </div>
      <div class="section-content">
        <el-row :gutter="40">
          <el-col :sm="24" :xl="12">
            代理方：
            <span>{{ detailInfo.agentCompanyName || ' - ' }}</span>
            <span class="m-l-20">
              {{ detailInfo.acceptEmployeeName || ' - ' }}
            </span>
            <span class="m-l-10">
              {{ detailInfo.acceptEmployeeMobile || ' - ' }}
            </span>
            <span class="m-l-10">
              {{ detailInfo.acceptEmployeeDeptName || ' - ' }}
            </span>
          </el-col>
          <!-- <el-col v-if="isJxic" :sm="24" :xl="12"> -->
          <el-col :sm="24" :xl="12">
            企业供应商库：
            {{ isAllowUseSrmDict.translate(isAllowUseSrm).label || '-' }}
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import { isAllowUseSrmDict } from '@/dictionary/supplier-management/supplier-lib'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    BaseSectionTitle
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    },
    isAllowUseSrm: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapGetters('company', ['platformTitle']),

    // 是否是省投及其下属企业，且是在采购工作台
    isJxic() {
      return this.platformTitle === '江西投资集团电子采购平台'
    }
  },

  data() {
    return {
      isAllowUseSrmDict
    }
  }
}
</script>

<style></style>
